import { defineComponent as v, computed as c, openBlock as r, createBlock as k, unref as l, withCtx as o, createElementBlock as i, Fragment as m, createVNode as e, renderSlot as b, normalizeStyle as N, createCommentVNode as C, normalizeClass as p, createElementVNode as $, toDisplayString as w, createTextVNode as B } from "vue";
import u from "./index60.js";
import { Disclosure as D, DisclosureButton as g, DisclosurePanel as x } from "./index304.js";
const P = { class: "min-w-0 flex-1" }, V = "px-4 pb-2 pt-4 text-sm text-gray-500 w-full", z = /* @__PURE__ */ v({
  __name: "BaseDisclosure",
  props: {
    defaultOpen: { type: Boolean, default: !1 },
    buttonText: { default: "" },
    panelContent: { default: "" },
    custom: { type: Boolean, default: !1 },
    color: { default: "gray" },
    showArrow: { type: Boolean, default: !0 },
    arrowPosition: { default: 16 }
  },
  setup(t) {
    const s = t, d = {
      red: {
        button: "bg-red-100 text-red-900 hover:bg-red-200 focus-visible:ring-red-500",
        icon: "text-red-500"
      },
      blue: {
        button: "bg-blue-100 text-blue-900 hover:bg-blue-200 focus-visible:ring-blue-500",
        icon: "text-blue-500"
      },
      gray: {
        button: "bg-gray-100 text-gray-900 hover:bg-gray-200 focus-visible:ring-gray-500",
        icon: "text-gray-500"
      },
      purple: {
        button: "bg-purple-100 text-purple-900 hover:bg-purple-200 focus-visible:ring-purple-500",
        icon: "text-purple-500"
      }
    }, y = c(() => {
      const a = "flex items-center w-full justify-between rounded-md px-4 py-2 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-opacity-75", f = d[s.color];
      return `${a} ${f.button}`;
    });
    c(() => d[s.color].icon);
    const h = c(() => ({
      right: `${s.arrowPosition}px`
    }));
    return (a, f) => (r(), k(l(D), {
      "default-open": s.defaultOpen,
      as: "div",
      class: "block w-full min-w-0"
    }, {
      default: o(({ open: n }) => [
        t.custom ? (r(), i(m, { key: 0 }, [
          e(l(g), {
            as: "div",
            class: "relative block w-full min-w-0"
          }, {
            default: o(() => [
              b(a.$slots, "button"),
              t.showArrow ? (r(), i("div", {
                key: 0,
                class: "absolute top-1/2 flex-shrink-0 -translate-y-1/2 transform",
                style: N(h.value)
              }, [
                e(u, {
                  name: "arrow-down",
                  className: `h-5 w-5 ${n ? "hidden" : "block"}`
                }, null, 8, ["className"]),
                e(u, {
                  name: "arrow-up",
                  className: `h-5 w-5 ${n ? "block" : "hidden"}`
                }, null, 8, ["className"])
              ], 4)) : C("", !0)
            ]),
            _: 2
          }, 1024),
          e(l(x), {
            as: "div",
            class: "block w-full min-w-0"
          }, {
            default: o(() => [
              b(a.$slots, "panel")
            ]),
            _: 3
          })
        ], 64)) : (r(), i(m, { key: 1 }, [
          e(l(g), {
            class: p(y.value),
            as: "div"
          }, {
            default: o(() => [
              $("span", P, w(t.buttonText), 1),
              e(u, {
                name: "arrow-down",
                className: `h-5 w-5 ${n ? "hidden" : "block"}`
              }, null, 8, ["className"]),
              e(u, {
                name: "arrow-up",
                className: `h-5 w-5 ${n ? "block" : "hidden"}`
              }, null, 8, ["className"])
            ]),
            _: 2
          }, 1032, ["class"]),
          e(l(x), {
            class: p(V),
            as: "div"
          }, {
            default: o(() => [
              B(w(t.panelContent), 1)
            ]),
            _: 1
          })
        ], 64))
      ]),
      _: 3
    }, 8, ["default-open"]));
  }
});
export {
  z as default
};
